import React from 'react';

/**
* Renders a skeleton placeholder for the challenge detail view while content loads.
* @example
* ChallengeDetailSkeleton({})
* <div className="animate-pulse p-6">...</div>
* @param {{}} props - Component props (none required).
* @returns {{JSX.Element}} Placeholder skeleton structure for the challenge detail.
**/
const ChallengeDetailSkeleton = () => {
  return (
    <div className="animate-pulse p-6">
      {/* Header */}
      <div className="mb-6">
        <div className="h-8 bg-background-tertiary rounded w-1/2 mb-4" />
        <div className="flex gap-3 mb-4">
          <div className="h-6 bg-background-tertiary rounded w-24" />
          <div className="h-6 bg-background-tertiary rounded w-32" />
        </div>
      </div>

      {/* Description */}
      <div className="mb-6 space-y-3">
        <div className="h-4 bg-background-tertiary rounded w-full" />
        <div className="h-4 bg-background-tertiary rounded w-5/6" />
      </div>

      {/* Problems List */}
      <div className="space-y-3">
        <div className="h-6 bg-background-tertiary rounded w-40 mb-4" />
        {[1, 2].map((i) => (
          <div key={i} className="bg-background-secondary rounded p-4 border border-border-primary">
            <div className="h-5 bg-background-tertiary rounded w-3/4" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChallengeDetailSkeleton;
